import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M7 12a.66.66 0 0 1-.472-.196L1.35 6.617a3.497 3.497 0 0 1 0-4.932A3.46 3.46 0 0 1 3.813.667c.933 0 1.808.362 2.464 1.018L7 2.409l.723-.724A3.46 3.46 0 0 1 10.187.667c.932 0 1.808.362 2.463 1.018a3.497 3.497 0 0 1 0 4.932l-5.178 5.188A.67.67 0 0 1 7 12",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }